import { useState } from "react";
import { api } from "../api";
import { comma } from "../constants";
import Card from "./ui/Card";
import Input from "./ui/Input";
import Btn from "./ui/Btn";
import Modal from "./ui/Modal";

export default function ReviewersMgmt({ reviewers, toast, refresh, user }) {
  const isReadOnly = user?.role === "auditor";
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    base_salary: 300,
    active: true,
  });

  const toggleActive = async (r) => {
    try {
      if (r.active) {
        await api(`/reviewers/${r.id}`, { method: "DELETE" });
        toast("⛔ تم إيقاف المراجع — لن يظهر بعد الآن كخيار فى بقية النظام");
      } else {
        await api(`/reviewers/${r.id}`, {
          method: "PUT",
          body: {
            name: r.name,
            phone: r.phone,
            email: r.email,
            base_salary: r.base_salary,
            active: true,
          },
        });
        toast("✅ تم تفعيل المراجع");
      }
      refresh();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  const save = async () => {
    if (!form.name) {
      toast("الاسم مطلوب", "warning");
      return;
    }
    try {
      if (modal === "add") await api("/reviewers", { method: "POST", body: form });
      else await api(`/reviewers/${form.id}`, { method: "PUT", body: form });
      toast("✅ تم الحفظ");
      setModal(null);
      refresh();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <h2
          style={{
            fontSize: 20,
            fontWeight: 800,
            margin: 0,
            color: "#f1f5f9",
          }}
        >
          👥 المراجعون
        </h2>
        {!isReadOnly && (
          <Btn
            onClick={() => {
              setForm({
                name: "",
                phone: "",
                email: "",
                base_salary: 300,
                active: true,
              });
              setModal("add");
            }}
            color="#22c55e"
          >
            + إضافة
          </Btn>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))",
          gap: 12,
        }}
      >
        {reviewers.map((r) => (
          <Card key={r.id} style={{ padding: "16px 18px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div>
                <div
                  style={{
                    color: "#f1f5f9",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  {r.name}
                </div>
                <div
                  style={{
                    color: "#64748b",
                    fontSize: 12,
                    marginTop: 2,
                  }}
                >
                  {r.phone || "—"}
                </div>
              </div>
              <span
                style={{
                  background: r.active ? "#052e16" : "#1c0303",
                  color: r.active ? "#22c55e" : "#ef4444",
                  borderRadius: 6,
                  padding: "2px 8px",
                  fontSize: 11,
                }}
              >
                {r.active ? "نشط" : "موقوف"}
              </span>
            </div>
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#f59e0b", fontWeight: 700 }}>
                {comma(r.base_salary)} ر.س
              </span>
              {!isReadOnly && (
                <div style={{ display: "flex", gap: 6 }}>
                  <Btn
                    size="sm"
                    color={r.active ? "#ef4444" : "#22c55e"}
                    onClick={() => toggleActive(r)}
                  >
                    {r.active ? "إيقاف" : "تفعيل"}
                  </Btn>
                  <Btn
                    size="sm"
                    color="#38bdf8"
                    onClick={() => {
                      setForm({ ...r });
                      setModal("edit");
                    }}
                  >
                    تعديل
                  </Btn>
                </div>
              )}
            </div>
          </Card>
        ))}
      </div>
      {modal && (
        <Modal
          title={modal === "add" ? "إضافة مراجع" : "تعديل مراجع"}
          onClose={() => setModal(null)}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input
              label="الاسم الكامل"
              value={form.name}
              onChange={(v) => setForm((f) => ({ ...f, name: v }))}
              required
            />
            <Input
              label="الجوال"
              value={form.phone || ""}
              onChange={(v) => setForm((f) => ({ ...f, phone: v }))}
            />
            <Input
              label="الراتب (ر.س)"
              type="number"
              value={form.base_salary}
              onChange={(v) =>
                setForm((f) => ({ ...f, base_salary: parseFloat(v) }))
              }
            />
            <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
              <Btn onClick={save} color="#22c55e" size="lg">
                💾 حفظ
              </Btn>
              <Btn onClick={() => setModal(null)} color="#64748b" size="lg">
                إلغاء
              </Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
